import React from 'react';
import { Switch, Redirect } from 'react-router-dom';
import _map from 'lodash/map';
import _values from 'lodash/values';
import { AppBarLayout, Breadcrumbs } from 'commons-ui';

import { BULK_ACTIONS_RESOURCES, PAGE_NAMES } from 'constant';
import AuthorizedRouteV2 from 'commons-ui/src/permission/AuthorizedRoute';

import BulkActionsHome from './BulkActionsHome';
import { URL, COMPONENT } from './helper';

const BulkActions: React.FC<{}> = () => {
	return (
		<>
			<AppBarLayout />
			<Breadcrumbs />
			<Switch>
				<AuthorizedRouteV2
					exact
					configPageName={PAGE_NAMES.bulkActions}
					path={`/${PAGE_NAMES.bulkActions}`}
					component={BulkActionsHome}
				/>
				{_map(_values(BULK_ACTIONS_RESOURCES), (resourceName: string) => (
					<AuthorizedRouteV2
						key={resourceName}
						configPageName={PAGE_NAMES.bulkActions}
						configResourceName={resourceName}
						path={URL[resourceName]}
						component={COMPONENT[resourceName]}
					/>
				))}
				<Redirect to={`/${PAGE_NAMES.bulkActions}`} />
			</Switch>
		</>
	);
};

export default BulkActions;
